import * as React from 'react';

import { Alert, Typography } from 'antd';

import Modal from 'v2/components/Shared/Modal';

const HELP_BANK_ACCOUNT_URL =
  'https://ajuda.eduzz.com/hc/pt-br/articles/1260807398070-Como-cadastrar-dados-banc%C3%A1rios-%C3%93rbita-';

type NewAccountWarningModalProps = {
  isOpen: boolean;
  setClose: () => void;
};

function NewAccountWarningModal({ isOpen, setClose }: NewAccountWarningModalProps) {
  return (
    <Modal
      open={isOpen}
      textTitle='Nova conta bancária'
      textProceedButton='OK'
      setClose={setClose}
      handleProceedClick={setClose}
      textReturnButton=''
      hideReturnButton
    >
      <Alert
        type='warning'
        showIcon
        message='Saldo insuficiente para cadastro'
        description={
          <>
            Para cadastrar uma conta bancária é necessário ter pelo menos R$ 100,01 de saldo disponível. Para mais
            informações,{' '}
            <Typography.Link href={HELP_BANK_ACCOUNT_URL} target='_blank' rel='noopener noreferrer'>
              clique aqui
            </Typography.Link>
            .
          </>
        }
      />
    </Modal>
  );
}

export { NewAccountWarningModal };
